export default "__VITE_ASSET__BU6lyYN___"